import { vision } from "@/scripts/sections/vision";

document.addEventListener('DOMContentLoaded', () => {
    vision().initVisionFadeText();
})